import useMembersPanelLogic from "./MembersPanel/MembersPanelLogic";
import useMembersPanelActions from "./MembersPanel/MembersPanelActions";
import MembersPanelView from "./MembersPanel/MembersPanelView";

export default function MembersPanel() {
  const logic = useMembersPanelLogic();

  const actions = useMembersPanelActions({
    authFetch: logic.authFetch,
    canManageUsers: logic.canManageUsers,
    canManageMemberships: logic.canManageMemberships,
    selectedUser: logic.selectedUser,
    membershipUser: logic.membershipUser,
    membershipForm: logic.membershipForm,
    setSelectedUser: logic.setSelectedUser,
    setDeleteOpen: logic.setDeleteOpen,
    setActionLoadingId: logic.setActionLoadingId,
    setBanner: logic.setBanner,
    setUsers: logic.setUsers,
    setMembershipOpen: logic.setMembershipOpen,
    setMembershipLoading: logic.setMembershipLoading,
    setMembershipSubmitting: logic.setMembershipSubmitting,
    setMembershipUser: logic.setMembershipUser,
    setMemberMemberships: logic.setMemberMemberships,
    setActiveMembership: logic.setActiveMembership,
    setPlans: logic.setPlans,
    setMembershipForm: logic.setMembershipForm,
    resetMembershipForm: logic.resetMembershipForm,
  });

  return <MembersPanelView {...logic} {...actions} />;
}